const MEDIA_TYPE_LABELS = ['Image', 'Video', 'Text'] as const;

export const getMediaTypeNameById = (mediaTypeId: number) =>
    MEDIA_TYPE_LABELS[mediaTypeId - 1];

const MEDIA_TYPE_LABEL_KEYS: Record<
    (typeof MEDIA_TYPE_LABELS)[number],
    string
> = {
    Image: 'filters.mediaType.image',
    Video: 'filters.mediaType.video',
    Text: 'filters.mediaType.text',
};

export const translateMediaTypeLabel = (
    name: string,
    t: (key: string, options?: { ns?: string }) => string,
) => {
    const key =
        MEDIA_TYPE_LABEL_KEYS[name as keyof typeof MEDIA_TYPE_LABEL_KEYS];

    return key ? t(key, { ns: 'common' }) : name;
};
